import * as React from "react";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { NotifFromGrafferType } from "../../../../application/domain/notifi-from-graffer/notif-from-graffer";
import { LinkButton } from "../../../atoms/link-button";
import { SettingR } from "../route";
import dayjs from "dayjs";
import ja from "dayjs/locale/ja";
import { InformationBanner, Pagination } from "@graffer-inc/console-design-kit";
import { Loader } from "../../../organisms/common/loading";

dayjs.locale(ja);

export const NotifFromGrafferListPage: React.FC<{
  list: NotifFromGrafferType[];
  onSelected: (index: NotifFromGrafferType) => void;
  movePage: (p: number) => void;
  paging: { current: number; total: number };
  isLoading: boolean;
}> = ({ list, onSelected, movePage, paging, isLoading }) => {
  return (
    <SettingsTemplate
      breadcrumbs={[
        {
          to: SettingR.NotifFromGraffer.link({}),
          title: "Grafferからのお知らせ",
        },
      ]}
    >
      <h1 className="title">
        <i className="fa fa-paperclip" /> Grafferからのお知らせ
      </h1>
      <Loader isLoading={isLoading}>
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>件名</th>
              <th>詳細</th>
              <th>お知らせ日</th>
              <th>最終更新日</th>
            </tr>
          </thead>
          <tbody>
            {list.map((notif) => (
              <tr key={notif.slug}>
                <td>{notif.title}</td>
                <td>
                  <LinkButton onClick={() => onSelected(notif)}>
                    詳細を確認
                  </LinkButton>
                </td>
                <td>
                  {dayjs(notif.metadata.startat).format("YYYY年MM月DD日")}
                </td>
                <td>{dayjs(notif.published_at).format("YYYY年MM月DD日")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Loader>
      {!isLoading && list.length === 0 && (
        <InformationBanner message="お知らせはありません。" />
      )}
      <div style={{ marginTop: "16px" }}>
        <Pagination
          onPageClick={movePage}
          currentPage={paging.current}
          lastPage={paging.total}
        />
      </div>
    </SettingsTemplate>
  );
};
